<template>
  <div>
    <div slot="toolbar">
      <el-button :loading="exportLoading" type="primary" @click="exportExcel">导出</el-button>
    </div>
    <div class="vm-search">
      <spna style="margin-right: 10px;font-size: 13px">开始时间</spna>
      <el-date-picker
          v-model="filter.handleTimeBegin"
          value-format="yyyy-MM-dd"
          type="date"
          style="width: 150px"
          placeholder="选择开始日期"/>
      <spna style="margin: 0 10px;font-size: 13px">至</spna>
      <el-date-picker
          v-model="filter.handleTimeEnd"
          value-format="yyyy-MM-dd"
          type="date"
          style="width: 150px"
          placeholder="选择结束日期"/>
      <vm-search label="部门">
        <el-select v-model.trim="filter.department" clearable placeholder="请选择部门" style="width: 150px">
          <el-option label="合同部" value="ContractDept"/>
          <el-option label="部件技术" value="DJTechForeCheck"/>
          <el-option label="电气技术" value="TechForeCheck"/>
        </el-select>
      </vm-search>
      <el-button
          :loading="searchLoading"
          type="primary"
          size="mini"
          style="height: 26px; padding: 0 10px; margin-left: 10px;"
          @click="getList">
        查询
      </el-button>
    </div>
    <el-table
        ref="table"
        v-loading="loading"
        border
        :default-sort="{prop: 'total', order: 'descending'}"
        :data="tableData"
        style="width: 100%"
        height="calc(100vh - 20vh)">
      <el-table-column prop="handlerName" align="center" label="处理人"/>
      <el-table-column prop="difficultyOne" align="center" label="难度1" sortable/>
      <el-table-column prop="difficultyTwo" align="center" label="难度2" sortable/>
      <el-table-column prop="difficultyThree" align="center" label="难度3" sortable/>
      <el-table-column prop="difficultyFour" align="center" label="难度4" sortable/>
      <el-table-column prop="difficultyFive" align="center" label="难度5" sortable/>
      <el-table-column prop="difficultySix" align="center" label="难度6" sortable/>
      <el-table-column prop="total" align="center" label="总分" sortable/>
    </el-table>
  </div>
</template>

<script>

  export default {
    name: "RegionalSummary",
    data() {
      return {
        exportLoading: false,
        loading: false,
        searchLoading: false,
        tableData: [],
        filter: {
          handleTimeBegin: "",
          handleTimeEnd: "",
          department:"",
        },
      };
    },
    mounted() {
      this.initTime();
    },
    methods: {
      initTime() {
        this.filter.handleTimeEnd = this.getFormatDate(new Date());
        this.filter.handleTimeBegin = this.getFormatDate1(new Date(new Date() - 3600 * 1000 * 24 * 29));
      },
      // 获取当前时间
      getFormatDate(date) {
        var month = date.getMonth() + 1;
        // var strDate = date.getDate();
        if (month >= 1 && month <= 9) {
          month = "0" + month;
        }
        // if (strDate >= 0 && strDate <= 9) {
        //   strDate = "0" + strDate;
        // }
        return date.getFullYear() + "-" + month + "-" + 25;
      },
      getFormatDate1(date) {
        var month = date.getMonth() + 1;
        // var strDate = date.getDate();
        if (month >= 1 && month <= 9) {
          month = "0" + month;
        }
        // if (strDate >= 0 && strDate <= 9) {
        //   strDate = "0" + strDate;
        // }
        return date.getFullYear() + "-" + month + "-" + 26;
      },
      getList() {
        let params = {
          handleTimeBegin: this.filter.handleTimeBegin,
          handleTimeEnd: this.filter.handleTimeEnd,
          department:this.filter.department,
        };
        this.loading = true;
        this.searchLoading = true;
        this.$http.get("basic", "orderProcessingStatistics", params).then(resp => {
          console.log(resp);
          this.tableData = resp;
          this.loading = false;
          this.searchLoading = false;
        }).catch(() => {
          this.loading = false;
          this.searchLoading = false;
        });
      },
      exportExcel() {
        this.exportLoading = true;
        this.$http
          .exportFile("basic", "orderProcessingStatistics/export", this.filter)
          .then(res => {
            console.log(res);
            let blob = new Blob([res.data]);
            let fileName = decodeURI(res.headers.filename);
            if (window.navigator && window.navigator.msSaveOrOpenBlob) {
              navigator.msSaveBlob(blob, fileName);
            } else {
              let a = document.createElement("a");
              a.href = URL.createObjectURL(blob);
              a.download = fileName;
              a.style.display = "none";
              document.body.appendChild(a);
              a.click();
              URL.revokeObjectURL(a.href);
              document.body.removeChild(a);
            }
            this.exportLoading = false;
          })
          .catch(() => {
            this.exportLoading = false;
          });
      },
    },
  };
</script>

<style lang="scss" scoped>
.vm-search {
  margin: 10px;
}
</style>